import { render, staticRenderFns } from "./EntrepreneurThumbnail.vue?vue&type=template&id=45ee2d56&scoped=true&"
import script from "./EntrepreneurThumbnail.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurThumbnail.vue?vue&type=style&index=0&id=45ee2d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ee2d56",
  null
  
)

export default component.exports